export default "__VITE_ASSET__B8jQW9q9__"